/**
 * Whether a rejected `fetch` failed to reach the server at all, rather than returning a response
 * we then rejected ourselves.
 *
 * @remarks `fetch` rejects with a `TypeError` when the request never completes — DNS failure, TLS
 * failure, a dropped connection, a blocking extension or proxy. The message is browser-specific
 * ("Load failed" on Safari, "Failed to fetch" on Chrome), so only the constructor is matched.
 *
 * Deliberately narrower than `isCancellation`'s duck-type: an abort can arrive as a `DOMException`
 * from several sources, whereas the network rejection is specified to be a `TypeError`, and
 * widening this would start catching our own `new Error(...)` throws in the same `.catch`.
 */
export function isNetworkError(reason: unknown): boolean {
  return reason instanceof TypeError;
}
